import React from 'react';
import { buttonStyles } from '../constants/theme/styles/components/buttonstyles';
import { ButtonWrapper } from './layout/button-wrapper';
import { ContentSpacer } from './layout/generic-content-spacer';

interface ActionProps {
	label: string;
	action: () => any;
}

interface Props {
	title?: string;
	description?: string;
	confirmAction?: ActionProps;
	cancelAction?: ActionProps;
}
export function ConfirmCancelModalContent(props: Props) {
	const { title, description, confirmAction, cancelAction } = props;
	const buttonClasses = buttonStyles();
	return (
		<>
			<ContentSpacer>
				<div className='rich-text'>
					{title && <h3>{title}</h3>}
					{description && <p>{description}</p>}
				</div>
			</ContentSpacer>
			<ButtonWrapper flexEnd>
				{cancelAction && <button type='button' className={buttonClasses.tertiaryButton} onClick={cancelAction?.action} >{cancelAction?.label}</button>}
				{confirmAction && <button type='button' className={buttonClasses.primaryButton} onClick={confirmAction?.action}>{confirmAction?.label}</button>}
			</ButtonWrapper >
		</>
	);
}

ConfirmCancelModalContent.defaultProps = {
	title: '',
	description: '',
	confirmAction: null,
	cancelAction: null,
};